document.addEventListener("DOMContentLoaded", function () {
  const heroSwiper = new Swiper(".hero-swiper .swiper", {
    loop: true,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    // },
    // pagination: {
    //  el: ".swiper-pagination",
    //  clickable: true,
    // },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    effect: "slide",
  });
});
